export enum VisitType {
  All = -100, // Used only for filtering
  Deleted = -1,
  Default = 0,
  Reservation = 1,
}
